import Image from "next/image";

import tuneIcon from "@/assets/icons/tune.svg";
import tuneActiveIcon from "@/assets/icons/tune-active.svg";
import SmallLoading from "@/components/shared/smallLoading";

type Props = {
  filterActive: boolean;
  clickHandler: () => void;
  label?: string;
  isLoading?: boolean;
};

/*クリックできる「絞り込み」と表示するフィルタするボタン */
const FilterButton: React.FC<Props> = ({
  filterActive,
  clickHandler,
  label,
  isLoading
}) => {
  return (
    <div
      className="flex cursor-pointer items-center gap-8"
      onClick={clickHandler}
    >
      <div className="mt-4">
        <Image
          src={filterActive ? tuneActiveIcon : tuneIcon}
          alt="絞り込み"
          width={24}
          height={24}
        />
      </div>
      {/* MEMO: 375px以下はフォントを小さく（iPhoneSE対策） */}
      {label && (
        <p
          className={`text-sm min-[376px]:text-md ${
            filterActive ? "text-cselected" : ""
          }`}
        >
          {label}
        </p>
      )}
      {isLoading && (
        <div className="text-left">
          <SmallLoading />
        </div>
      )}
    </div>
  );
};

export default FilterButton;
